var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.267832 11.469L8.64783 19.859C8.83783 20.049 9.14783 20.049 9.33783 19.859L17.7278 11.469C18.0378 11.159 17.8178 10.629 17.3778 10.629H15.9878C15.8578 10.629 15.7378 10.679 15.6378 10.769L9.97783 16.449V0.489023C9.97783 0.219023 9.75783 -0.000976562 9.48783 -0.000976562H8.50783C8.23783 -0.000976563 8.01783 0.219023 8.01783 0.489023V16.449L2.34783 10.779C2.25783 10.689 2.12783 10.639 1.99783 10.639H0.617832C0.177832 10.639 -0.0321685 11.169 0.267832 11.479V11.469Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/IconArrowDown.b1f6858eac7cffcbd638c357769d1a45.svg";
export { ForwardRef as ReactComponent };